export class AnoSafra {
    Id: number;
    Descricao:string = "";
    AnoAgricolaId: number;
    FazendaId: number;
    FazendasId: number[];
    Status: EnumStatusAnoSafra
    AreaPlantada: number
    CustoPorHA: number
    DataCadastro: Date
}

export enum EnumStatusAnoSafra{
    NaoIniciado = 0,
    Iniciado = 1,
    Finalizado = 2,

}
